import { useCheckAccountTraits } from '@cmg/auth';
import {
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@cmg/design-system';

import { AttestationForm } from '../../../../../../graphql';
import { Attestation } from '../../context/hooks/certificates/useCertificatesModel';
import { CertificateTableRow } from './CertificateTableRow';

export type Props = {
  attestation: Attestation | null;
  attestationForm?: AttestationForm | null;
  isSellSide?: boolean;
  isCertificatesVisibleForOffering?: boolean;
};

const CertificateTable: React.FC<Props> = ({
  attestation,
  attestationForm,
  isSellSide,
  isCertificatesVisibleForOffering,
}) => {
  const hasCertificateLibraryTrait = useCheckAccountTraits(['CERTIFICATE_LIBRARY']);
  return (
    <Stack spacing={2}>
      <TableContainer>
        <Table sx={{ minWidth: 500 }}>
          <TableHead>
            <TableRow>
              <TableCell colSpan={1} />
              <TableCell>Certificate</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Signature Date</TableCell>
              <TableCell>Expiration</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {attestation && (
              <CertificateTableRow attestation={attestation} attestationForm={attestationForm} />
            )}
            {!hasCertificateLibraryTrait && isCertificatesVisibleForOffering && isSellSide && (
              <TableRow role="progressbar">
                <TableCell size="small" />
                {[...Array(5)].map((_, i) => (
                  <TableCell key={i} size="small">
                    <Skeleton />
                  </TableCell>
                ))}
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {!attestation && (hasCertificateLibraryTrait || !isCertificatesVisibleForOffering) && (
        <Stack alignItems="center" width="100%" mt={2}>
          <Typography variant="subtitle1" color="text.primary">
            No certificates specified as required
          </Typography>
        </Stack>
      )}
    </Stack>
  );
};

export default CertificateTable;
